import { date } from "@lumberset/takeoff-ui";
import { Container, EmptyState, Input, SectionHeader, Skeleton, Table } from "@lumberset/ui";
import { Buildings, MagnifyingGlass } from "@medusajs/icons";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useDeferredValue, useState } from "react";
import { Crumbs } from "../../../components/crumbs";
import { SubscriptionStatus } from "../../../components/subscription-badge";
import { yardsQuery } from "../../../lib/queries";

export const Route = createFileRoute("/_app/yards/")({ component: Yards });

function Yards() {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const q = useDeferredValue(text);
  const { data, isPending } = useQuery(yardsQuery(q.trim() || undefined));

  return (
    <>
      <Crumbs trail={[{ label: "Workspaces" }]} />

      <Container className="divide-y p-0">
        <SectionHeader
          level="h1"
          title="Workspaces"
          description="Every lumber yard and builder on LumberSet, newest first. Open one for its people, takeoffs and billing."
        />
        <div className="px-6 py-3 sm:max-w-xs">
          <Input
            type="search"
            placeholder="Search by name"
            prefix={<MagnifyingGlass />}
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
        </div>

        {isPending ? (
          <div className="flex flex-col gap-y-3 px-6 py-4">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-5 w-1/2" />
          </div>
        ) : !data || data.yards.length === 0 ? (
          <EmptyState
            icon={<Buildings />}
            title={q ? "Nothing matches" : "No workspaces yet"}
            description={q ? "Try a different name." : "Workspaces appear here as they sign up."}
          />
        ) : (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Subscription</Table.HeaderCell>
                <Table.HeaderCell className="max-sm:hidden">Card on file</Table.HeaderCell>
                <Table.HeaderCell className="max-md:hidden">Created</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data.yards.map((yard) => (
                <Table.Row
                  key={yard.id}
                  data-clickable="true"
                  onClick={() => navigate({ to: "/yards/$id", params: { id: yard.id } })}
                >
                  <Table.Cell>
                    <div className="txt-compact-small-plus text-ui-fg-base">{yard.name}</div>
                    <div className="txt-compact-xsmall text-ui-fg-muted">
                      {yard.kind === "builder" ? "Builder" : "Lumber yard"}
                    </div>
                  </Table.Cell>
                  <Table.Cell className="whitespace-nowrap">
                    <SubscriptionStatus status={yard.status} />
                  </Table.Cell>
                  <Table.Cell className="max-sm:hidden">
                    {yard.hasPaymentMethod ? "Yes" : "No"}
                  </Table.Cell>
                  <Table.Cell className="whitespace-nowrap max-md:hidden">
                    {date(yard.createdAt)}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </Container>
    </>
  );
}
